export enum AddCashSteps {
  Form = 'add-cash-form',
  Preview = 'add-cash-preview',
}
